import { useTheme } from '../context/ThemeContext'

function WellsTable({ wells, onWellClick, viewMode = 'gross' }) {
    const { theme } = useTheme()
    const isNet = viewMode === 'net'

    if (!wells || wells.length === 0) {
        return (
            <div className="text-center py-8 text-gray-400">
                No well data available
            </div>
        )
    }

    return (
        <div className="overflow-x-auto">
            <table className="data-table">
                <thead>
                    <tr>
                        <th>Well Name</th>
                        <th>County</th>
                        <th>State</th>
                        <th className="text-right">{isNet ? 'Net Oil' : 'Oil'} (BBL)</th>
                        <th className="text-right">{isNet ? 'Net Gas' : 'Gas'} (MCF)</th>
                        {!isNet && <th className="text-right">Water (BBL)</th>}
                        <th className="text-right">Uptime %</th>
                    </tr>
                </thead>
                <tbody>
                    {wells.map((well, index) => (
                        <tr key={well.unitId || index}
                            className={onWellClick ? 'cursor-pointer' : ''}
                            onClick={() => onWellClick && onWellClick(well.unitId)}>
                            <td className="font-medium">
                                {well.unitName || well.wellName || 'N/A'}
                                {onWellClick && (
                                    <span className={`ml-2 text-xs ${theme === 'dark' ? 'text-blue-400' : 'text-blue-600'}`}>&rarr;</span>
                                )}
                            </td>
                            <td className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}>
                                {well.county || 'N/A'}
                            </td>
                            <td className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}>
                                {well.state || 'N/A'}
                            </td>
                            <td className="text-right font-mono">
                                {(isNet ? well.netOil : well.totalOil)?.toLocaleString() || '0'}
                            </td>
                            <td className="text-right font-mono">
                                {(isNet ? well.netGas : well.totalGas)?.toLocaleString() || '0'}
                            </td>
                            {!isNet && (
                                <td className="text-right font-mono">
                                    {well.totalWater?.toLocaleString() || '0'}
                                </td>
                            )}
                            <td className="text-right">
                                <span className={`inline-flex px-2 py-1 rounded text-xs font-semibold ${
                                    well.uptimePercent >= 90
                                        ? theme === 'dark' ? 'bg-green-900 text-green-200' : 'bg-green-100 text-green-800'
                                        : well.uptimePercent >= 70
                                        ? theme === 'dark' ? 'bg-yellow-900 text-yellow-200' : 'bg-yellow-100 text-yellow-800'
                                        : theme === 'dark' ? 'bg-red-900 text-red-200' : 'bg-red-100 text-red-800'
                                }`}>
                                    {well.uptimePercent?.toFixed(1) || '0'}%
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default WellsTable
